import React from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ post }) => {
  return (
    <div className="blog-card">
      <img src={post.image} alt={post.title} className="blog-image" />
      <div className="card-content">
        <span className="card-date">Date : {post.date}</span>
        <h3 className="card-title">{post.title}</h3>
        <p className="card-snippet">{post.snippet}</p>
        <Link to={`/blog/${post.slug}`} className="read-more">
          Read More
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;